import { render } from "./TorneiComponent.vue?vue&type=template&id=44361dc1"
import script from "./TorneiComponent.vue?vue&type=script&lang=js"
export * from "./TorneiComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__